import { getJwtRoles, useSession } from '@descope/react-sdk';
import { Navigate } from 'react-router-dom';

export default function ProtectedRoute({ children }) {
    const { isAuthenticated, sessionToken } = useSession();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const roles =  getJwtRoles(sessionToken)
  if (roles.includes("callcenter_agent")) {
    return children;
  }

  return <Navigate to="/login" replace />;
}
